import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, SimpleChange, QueryList, ViewEncapsulation, Optional, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Flow } from '../obj/Flow';
// import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { FlowManagementService } from '../services/flow-management.service';
import { WindowRef, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { Connection } from '../obj/Connection';
import { NgxEditorModel } from 'ngx-monaco-editor-v2';
import { FlowEventService, FlowEvent } from '../services/flow-event.service';

// export enum EditorType {
//     Flow,
//     Connector,
//     Connection,
//     FlowOwners
// }

@Component({
    selector: 'app-flow-detail',
    templateUrl: './flow.detail.component.html',
    styleUrls: ['./flow.detail.component.scss'],
    //styles: ['ngx-monaco-editor { height: 500px; display:block; }'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class FlowDetailComponent implements OnInit, AfterViewInit, OnChanges {

    constructor(
        private flowManagementService: FlowManagementService,
        private flowEventService: FlowEventService,
        @Optional() public windowRef: WindowRef,
        private dialogService: DialogService,
        private router: Router,
    ) {
        //this.editorOptions = new JsonEditorOptions()
        //this.editorOptions.modes = ['code', 'tree']; // set all allowed modes
        //this.editorOptions.mode = 'code'; //set only one mode
        //this.data = { "products": [{ "name": "car", "product": [{ "name": "honda", "model": [{ "id": "civic", "name": "civic" }, { "id": "accord", "name": "accord" }, { "id": "crv", "name": "crv" }, { "id": "pilot", "name": "pilot" }, { "id": "odyssey", "name": "odyssey" }] }] }] }
    }

    editorOptions = { /*theme: 'vs-dark',*/ language: 'json', automaticLayout: true };
    code: string = '';

    @Input() editorType: string;
    @Input() flow: Flow;
    @Input() connection: Connection;
    @Input() admin: boolean = false;

    /**
     * True when any toolbar button is renderable. Used by the template to
     * collapse the entire `<kendo-toolbar>` row when it would render empty
     * (e.g. Connector mode in route mode: Save hidden because read-only,
     * Cancel hidden because no popup, Advanced Edit hidden because not Flow).
     */
    get hasToolbarButtons(): boolean {
        const t = `${this.editorType ?? ''}`;
        const showSave = t === 'Flow' || t === 'FlowAdvanced' || t === 'Connection';
        const showCancel = !!this.windowRef;
        const showAdvanced = t === 'Flow' || t === 'FlowAdvanced';
        return showSave || showCancel || showAdvanced;
    }
    flowData: any;
    //public editorOptions: JsonEditorOptions;
    //@ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    editor = null;
    error: string;
    ready = false;
    private viewReady = false;

    ngOnChanges(changes: SimpleChanges) {
        if (!this.viewReady) return;
        if (changes.editorType || changes.flow || changes.connection || changes.admin) {
            this.loadEditorData();
        }
    }

    // model: NgxEditorModel = {
    //     value: this.code,
    //     language: 'json',
    //     uri: 'workflowdefinition.json'
    // };


    ngOnInit() {

    }

    ngAfterViewInit() {
        this.viewReady = true;
        this.loadEditorData();
    }

    private loadEditorData() {
        this.ready = false;
        this.error = null;
        if (this.editorType == "Flow" && this.flow) {
            this.flowManagementService.getFlow(this.flow.environment, this.flow.flowName).toPromise().then(flow => {
                this.flowData = flow;
                this.flow.definition = flow.properties.definition;
                this.code = JSON.stringify(this.flow.definition, undefined, 2);
                //this.model.value = this.code;
                //this.model.uri = 'workflowdefinition.json';
                this.ready = true;
            }, (response) => {
                this.error = response.error || response;
                this.ready = true;
            });
        }
        if (this.editorType == "FlowAdvanced" && this.flow) {
            this.flowManagementService.getFlow(this.flow.environment, this.flow.flowName).toPromise().then(flow => {
                this.flowData = flow;
                //this.flow.definition = flow.properties.definition;
                this.code = JSON.stringify(this.flowData, undefined, 2);
                //this.model.value = this.code;
                //this.model.uri = 'workflowdefinition.json';
                this.ready = true;
            }, (response) => {
                this.error = response.error || response;
                this.ready = true;
            });
        }
        if (this.editorType == "FlowOwners" && this.flow) {
            this.flowManagementService.getFlowOwners(this.flow, this.admin).toPromise().then(flow => {
                this.flowData = flow;
                this.code = JSON.stringify(this.flowData, undefined, 2);
                //this.editor.set(this.flowData);
                // this.model.value = this.code;
                // this.model.uri = 'owners.json';
                this.ready = true;
            }, (response) => {
                this.error = response.error || response;
                this.ready = true;
            });
        }
        if (this.editorType == "Connector" && this.connection) {
            this.flowManagementService.getConnector(this.connection).toPromise().then(connector => {
                this.code = JSON.stringify(connector, undefined, 2);
                //this.editor.set(connector);
                // this.model.value = this.code;
                // this.model.uri = 'connector.json';
                this.ready = true;
            }, (response) => {
                this.error = response.error || response;
                this.ready = true;
            });
        }
        if (this.editorType == "Connection" && this.connection) {
            this.flowManagementService.getConnection(this.connection).toPromise().then(connection => {
                this.code = JSON.stringify(connection, undefined, 2);
                //this.editor.set(connection);
                // this.model.value = this.code;
                // this.model.uri = 'connection.json';
                this.ready = true;
            }, (response) => {
                this.error = response.error || response;
                this.ready = true;
            });
        }
    }

    onInit(editor) {
        //let line = editor.getPosition();
        //console.log(line);
        this.editor = editor;
        // this.editor.setValue(this._code);
        // this.editor.layout();
        //debugger
    }

    public onSaveClick(): void {
        // console.log("on click");

        if (this.flow) {
            if (this.editorType == "Flow" || this.editorType == "FlowAdvanced") {
                try {

                    this.ready = false;
                    //var flowData :any = this.editor.get();
                    //var code = this.editor.getValue();
                    //debugger;

                    // this.code = this.model.value;
                    var definition;
                    try {
                        definition = JSON.parse(this.code);
                    }
                    catch (error) {
                        this.error = error;
                        this.ready = true;

                        return;
                    }
                    if (this.editorType == "FlowAdvanced") {
                        this.flowData = definition;
                    }
                    else {
                        this.flowData.properties.definition = definition;
                    }
                    // this.flowManagementService.validateFlow(this.flow.environment, this.flow.flowName, body).map((response) => { return response.json(); }).toPromise().then(()=>{
                    this.flowData.tags = {
                        "kunai-tags": "kunai-customized"
                    };

                    this.flowManagementService.updateFlow(this.flow.environment, this.flow.flowName, this.flowData).toPromise().then((response) => {
                        //alert('done!');
                        this.ready = true;
                        this.close();
                    }, (response) => {
                        this.error = response.error || response;
                        this.ready = true;
                    });
                }
                catch {

                }

            }
            if (this.editorType == "FlowOwners") {
                //var flowData :any = this.editor.get();
                // this.code = this.model.value;
                var flowData = JSON.parse(this.code);
                // this.flowManagementService.validateFlow(this.flow.environment, this.flow.flowName, body).map((response) => { return response.json(); }).toPromise().then(()=>{

                if (flowData["delete"]) {
                    var owner = flowData.delete[0].name;
                    this.flowManagementService.deleteFlowOwnerAsAdmin(this.flow, owner).toPromise().then((response) => {
                        //alert('done!');
                        this.close();
                    }, (response) => {
                        this.error = response.error || response;
                    });
                }
                else {
                    this.flowManagementService.modifyOwnersAsAdmin(this.flow, flowData).toPromise().then((response) => {
                        //alert('done!');
                        this.close();
                    }, (response) => {
                        this.error = response.error || response;
                    });
                }
            }
        }

        if (this.editorType == "Connection" && this.connection) {
            //var definition = this.editor.get();
            // this.code = this.model.value;
            var definition = JSON.parse(this.code);
            // this.flowManagementService.validateFlow(this.flow.environment, this.flow.flowName, body).map((response) => { return response.json(); }).toPromise().then(()=>{
            // this.flowData.properties.definition = definition;
            // this.flowData.tags = {
            //     "kunai-tags": "kunai-customized"
            // };

            if (definition['properties']) {

                if (definition['properties'].environment) {
                    delete definition['properties'].environment;
                }
                if (definition['properties'].statuses) {
                    delete definition['properties'].statuses;
                }
                if (definition['properties'].connectionParameters) {
                    delete definition['properties'].connectionParameters;
                }
                if (definition['properties'].createdBy) {
                    delete definition['properties'].createdBy;
                }
                if (definition['properties'].keywordsRemaining) {
                    delete definition['properties'].keywordsRemaining;
                }
                if (definition['properties'].createdTime) {
                    delete definition['properties'].createdTime;
                }
                if (definition['properties'].lastModifiedTime) {
                    delete definition['properties'].lastModifiedTime;
                }
            }
            this.flowManagementService.updateConnection(this.connection, definition).toPromise().then((response) => {
                //alert('done!');
                this.close();
            }, (response) => {
                this.error = response.error || response;
            });

        }

        // });
    }

    close() {
        if (this.windowRef) {
            this.windowRef.close();
        }

        let type = "app-flow-detail";
        switch(this.editorType){
            case "Connector":
                type = "app-connector-detail";
                break;
            case "Connection":
                type = "app-connection-detail";
                break;
        }

        this.flowEventService.closeTabWindow$.emit({
            value: false,
            type: type,
            flow: this.flow,
            connection: this.connection
        });
    }

    async advanced() {
        // Advanced edit now navigates to the flow's JSON tab with
        // ?advanced=true. flow-view picks that up and renders this same
        // component in editorType="FlowAdvanced" mode. If we're hosted in a
        // popup, close it as the user moves to the route page.
        if (!this.flow?.environment || !this.flow?.flowName) return;
        await this.router.navigate(
            ['/flows', this.flow.environment, this.flow.flowName, 'json'],
            { queryParams: { advanced: 'true' }, queryParamsHandling: 'merge' }
        );
        if (this.windowRef) {
            this.windowRef.close();
        }
    }

    async definitionOnly() {
        if (!this.flow?.environment || !this.flow?.flowName) return;
        await this.router.navigate(
            ['/flows', this.flow.environment, this.flow.flowName, 'json'],
            { queryParams: { advanced: null }, queryParamsHandling: 'merge' }
        );
        if (this.windowRef) {
            this.windowRef.close();
        }
    }
}
